import type { Robot } from '$lib/patterns/strategy/examples/types';
type Message = Robot.Message;
import Dad_Joke_Bot_Maker from './shared/inheritance/Dad_Joke_Bot';
import Stoicism_Bot_Maker from './shared/inheritance/Stoicism_Bot';
import Comedian_Bot_Maker from './shared/inheritance/Comedian_Bot';
import { Cache } from './shared/Cache';








abstract class Chatbot {

	abstract readonly name: string;
	abstract readonly avatar: string;
	abstract readonly description: string;

	abstract getContent(): Promise<string>;
	isCachable(): boolean {
		return false;
	}
	getLogMessage(): string {
		if (!this.isCachable()) {
			return `[${this.name}] Cache: NONE`;
		}
		if (Cache.has(this.name)) {
			return `[${this.name}] Cache: HIT`;
		}
		return `[${this.name}] Cache: MISS`;
	}

	async maybeGetCachedJoke() {
		let content;

		if (this.isCachable()) {
			content = Cache.get(this.name)
		}

		if (!content) {
			content = await this.getContent();
			if (this.isCachable()) {
				Cache.set(this.name, content);
			}
		}
		return content;
	}

	async getMessage(): Promise<Message> {
		return {
			author: this.name,
			avatar: this.avatar,
			log: this.getLogMessage(),
			time: new Date().toLocaleTimeString(),
			content: await this.maybeGetCachedJoke(),
		};
	}
}





const Dad_Joke_Bot = Dad_Joke_Bot_Maker(Chatbot);
const Stoicism_Bot = Stoicism_Bot_Maker(Chatbot);
const Comedian_Bot = Comedian_Bot_Maker(Chatbot);

export default {
	Chatbot: {
		class: Chatbot,
	},
	Dad_Joke_Bot: {
		class: Dad_Joke_Bot,
		init: () => new Dad_Joke_Bot(),
	},
	Stoicism_Bot: {
		class: Stoicism_Bot,
		init: () => new Stoicism_Bot(),
	},
	Comedian_Bot: {
		class: Comedian_Bot,
		init: () => new Comedian_Bot(),
	},
};